import React, { useEffect, useState } from "react";
import { usePackageContext, useProposalContext } from "../..";
import {
  Box,
  TableCell,
  styled,
  Divider,
  Stack,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./styles";
import { getApiData } from "../../../../utils/APIHelper";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import { toast } from "react-toastify";
import ConfirmModel from "../../../../components/ConfirmModel";
import { MdOutlineEdit, MdOutlineDelete } from "react-icons/md";
import InclusionModal from "../../../../components/InclusionModal";
import {
  formattedAmountWithoutAed,
  getImageSrc,
} from "../../../../utils/CommonFunction";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
  padding: "0 !important",
}));

const AddStyledButton = styled(Button)(({ theme }) => ({
  background: "#0000000A",
  color: "#4D6BF6",
  boxShadow: "none",
  border: "none",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function Inclusions() {
  const { packageDetails, setPackageDetails } = usePackageContext();
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const [selectedDeleteMilestone, setSelectedDeleteMilestone] = useState(null);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (packageDetails && packageDetails?.id) {
      getDetailsApiCall(packageDetails?.id);
    }
  }, [packageDetails?.id]);

  async function getDetailsApiCall(id) {
    setLoader(true);
    try {
      const response = await getApiData(
        `api/v2/package/${id}`,
        "GET",
        {},
        { "Content-Type": "application/json" },
        true
      );
      if (response) {
        setPackageDetails(response);
      }
      setLoader(false);
    } catch (error) {
      console.log("error:===>>>", error);
      setLoader(false);
    }
  }

  const handleClick = (item) => {
    console.log("item", item);
    navigate(`/new-create-package/${packageDetails?.id}/inclusion/${item.id}`, {
      state: { inclusionData: item, project: packageDetails },
    });
  };

  const handlePrevious = () => {
    navigate(`/new-create-package/${packageDetails?.id}`);
  };

  const handleNext = () => {
    if (!packageDetails?.inclusions?.length) {
      toast.error("Please add at least one BOQ to proceed");
      return;
    }

    // Navigate to groups if isGroup is true, otherwise to images
    const nextRoute = packageDetails?.isGroup ? 'groups' : 'images';
    navigate(`/new-create-package/${packageDetails?.id}/${nextRoute}`);
  };

  const handleCloseModal = () => setSelectedMilestone(null);

  const handleModalClose = () => {
    navigate("/packages");
  };

  async function handleConfirm() {
    try {
      const response = await getApiData(
        `api/v2/package/${packageDetails?.id}/boq/${selectedDeleteMilestone?.id}`,
        "DELETE",
        {},
        { "Content-Type": "application/json" },
        true
      );
      toast.success("Budget Deleted Successfully");
      setSelectedDeleteMilestone(null);
      getDetailsApiCall(packageDetails?.id);
    } catch (error) {
      console.log("err===>", error);
    }
  }

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(packageDetails.inclusions);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setPackageDetails((prev) => ({
      ...prev,
      inclusions: items,
    }));
  };

  useEffect(() => {
    console.log("pac", packageDetails.inclusions);
  }, [packageDetails]);

  return (
    <div style={{ ...styles.container, ...styles.columnFlex, gap: "15px" }}>
      <h3 style={styles.heading}>Inclusions</h3>
      {loader ? (
        <center>
          <CircularProgress />
        </center>
      ) : (
        // <DragDropContext onDragEnd={handleDragEnd}>
        //   <Droppable droppableId="inclusions-list">
        //     {(provided) => (
        //       <div
        //         ref={provided.innerRef}
        //         {...provided.droppableProps}
        //         style={{ ...styles.columnFlex, gap: "10px" }}
        //       >
        //         {packageDetails?.inclusions?.map((item, idx) => (
        //           <Draggable key={item.id.toString()} draggableId={item.id.toString()} index={idx}>
        //             {(provided) => (
        //               <div
        //                 ref={provided.innerRef}
        //                 {...provided.draggableProps}
        //                 {...provided.dragHandleProps}
        //                 style={{
        //                   ...styles.budgetRow,
        //                   ...provided.draggableProps.style,
        //                 }}
        //               >
        //                 <div
        //                   style={{
        //                     ...styles.rowFlex,
        //                     flex: 1,
        //                     cursor: "pointer",
        //                   }}
        //                   onClick={() => handleClick(item)}
        //                 >
        //                   <Box display="flex" alignItems="center">
        //                     <Box
        //                       component="img"
        //                       src={getImageSrc(item?.image?.path)}
        //                       alt="Inclusion Icon"
        //                       sx={{
        //                         width: 35,
        //                         height: 35,
        //                         borderRadius: "8px",
        //                         border: "2px solid white",
        //                         boxShadow: "0px 4px 2.67px 0px #00000026",
        //                         marginRight: 1,
        //                       }}
        //                     />
        //                     <span style={styles.small_sub_heading}>
        //                       {item?.name}
        //                     </span>
        //                   </Box>
        //                 </div>

        //                 <div style={{ ...styles.rowFlex, flex: 1 }}>
        //                   <div style={styles.small_text}>
        //                     <div
        //                       style={{
        //                         ...styles.rowFlex,
        //                         ...styles.small_sub_heading,
        //                       }}
        //                     >
        //                       <NewDesignIcon />
        //                       {item?.materialType}
        //                     </div>
        //                   </div>
        //                 </div>

        //                 <div style={{ ...styles.columnFlex, flex: 1 }}>
        //                   <h3 style={styles.small_text}>Units</h3>
        //                   <div style={styles.small_sub_heading}>
        //                     {item?.materialUnit}
        //                   </div>
        //                 </div>

        //                 <div style={{ ...styles.columnFlex, flex: 1 }}>
        //                   <h3 style={styles.small_text}>Description</h3>
        //                   <div style={styles.small_sub_desc}>
        //                     {item?.description}
        //                   </div>
        //                 </div>

        //                 <div style={{ ...styles.rowFlex, flex: 0.3 }}>
        //                   <div style={{ ...styles.rowFlex }}>
        //                     <MdOutlineEdit
        //                       onClick={() => setSelectedMilestone(item)}
        //                       style={{
        //                         cursor: "pointer",
        //                         fontSize: "1.3rem",
        //                         color: "#0D0D0E",
        //                       }}
        //                     />
        //                     <MdOutlineDelete
        //                       style={{
        //                         cursor: "pointer",
        //                         fontSize: "1.3rem",
        //                         color: "#e54746",
        //                       }}
        //                       onClick={() => setSelectedDeleteMilestone(item)}
        //                     />
        //                   </div>
        //                 </div>
        //               </div>
        //             )}
        //           </Draggable>
        //         ))}
        //         {provided.placeholder}
        //       </div>
        //     )}
        //   </Droppable>
        // </DragDropContext>
        <div
          style={{
            ...styles.columnFlex,
            gap: "10px",
          }}
        >
          {packageDetails?.inclusions?.map((item, idx) => (
            <div style={styles.budgetRow} key={item.id}>
              <div
                style={{ ...styles.rowFlex, flex: 1, cursor: "pointer" }}
                onClick={() => handleClick(item)}
              >
                <Box display="flex" alignItems="center">
                  <Box
                    component="img"
                    src={getImageSrc(item?.image?.path)}
                    alt="Inclusion Icon"
                    sx={{
                      width: 35,
                      height: 35,
                      borderRadius: "8px",
                      border: "2px solid white",
                      boxShadow: "0px 4px 2.67px 0px #00000026",
                      marginRight: 1,
                    }}
                  />
                  <span style={styles.small_sub_heading}>{item?.name}</span>
                </Box>
              </div>

              <div style={{ ...styles.rowFlex, flex: 1 }}>
                <div style={styles.small_text}>
                  <div
                    style={{ ...styles.rowFlex, ...styles.small_sub_heading }}
                  >
                    <NewDesignIcon />
                    {item?.materialType}
                  </div>
                </div>
              </div>

              <div style={{ ...styles.columnFlex, flex: 1 }}>
                <h3 style={styles.small_text}>Units</h3>
                <div style={styles.small_sub_heading}>{item?.materialUnit}</div>
              </div>
              {packageDetails?.isGroup &&
                <div style={{ ...styles.columnFlex, flex: 1 }}>
                  <h3 style={styles.small_text}>Cost</h3>
                  <div
                    style={{
                      ...styles.small_sub_heading,
                      ...styles.rowFlex,
                      gap: "5px",
                    }}
                  >
                    {item?.cost && renderCurrencyIcon('small')}
                    {item?.cost ? formattedAmountWithoutAed(item?.cost) : "-"}
                  </div>
                </div>
              }

              <div style={{ ...styles.columnFlex, flex: 1 }}>
                <h3 style={styles.small_text}>Description</h3>
                <div style={styles.small_sub_desc}>{item?.description}</div>
              </div>

              <div
                style={{
                  ...styles.rowFlex,
                  flex: 0.3,
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ ...styles.rowFlex }}>
                  <MdOutlineEdit
                    onClick={() => setSelectedMilestone(item)}
                    style={{
                      cursor: "pointer",
                      fontSize: "1.3rem",
                      color: "#0D0D0E",
                    }}
                  />
                  <MdOutlineDelete
                    style={{
                      cursor: "pointer",
                      fontSize: "1.3rem",
                      color: "#e54746",
                    }}
                    onClick={() => setSelectedDeleteMilestone(item)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <StyledTableCell>
        <AddStyledButton onClick={() => setSelectedMilestone({})}>
          + Add Budget Item
        </AddStyledButton>
      </StyledTableCell>

      {selectedMilestone && (
        <InclusionModal
          isCreationOpen={Boolean(selectedMilestone)}
          visible={Boolean(selectedMilestone)}
          handleCloseCreation={handleCloseModal}
          selectedBudget={selectedMilestone}
          isEdit={Object.keys(selectedMilestone).length !== 0}
          packageId={packageDetails?.id}
          getProjectDetails={getDetailsApiCall}
          isGroup={packageDetails?.isGroup}
        />
      )}

      {selectedDeleteMilestone && (
        <ConfirmModel
          visible={!!selectedDeleteMilestone}
          handleClose={() => setSelectedDeleteMilestone(null)}
          confirmation={handleConfirm}
          message={`Are you sure you want to delete ${selectedDeleteMilestone?.name}?`}
        />
      )}

      <Divider sx={{ width: "100%" }} />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GreyStyledButton onClick={handlePrevious}>
          {buttonLoader ? (
            <CircularProgress size={26} style={{ color: "#fff" }} />
          ) : (
            "Previous Step"
          )}
        </GreyStyledButton>

        <Stack
          alignItems="end"
          flexDirection="row"
          justifyContent="flex-end"
          gap="10px"
        >
          <GreyStyledButton onClick={handleModalClose}>Cancel</GreyStyledButton>
          <StyledButton variant="contained" onClick={handleNext}>
            {buttonLoader ? (
              <CircularProgress size={26} style={{ color: "#fff" }} />
            ) : (
              "Save & Continue"
            )}
          </StyledButton>{" "}
        </Stack>
      </Stack>
    </div>
  );
}
export default Inclusions;
